module.exports = __webpack_public_path__ + "img/star.df0915b5.svg";